export enum CurrenciesEnum {
  USD = 'usd',
  USDC = 'USDC',
  BRL = 'brl',
  BRLA = 'BRLA',
}

export type BlockchainCurrenciesEnum = Extract<
  CurrenciesEnum,
  CurrenciesEnum.BRLA | CurrenciesEnum.USDC
>
